<template>
  <b-container fluid class="py-3">
    <b-row>
      <b-col>
        <SkeletonTableLoader :columns="headers" :loading="loading" />
        <div v-if="!loading">
          <MasterEmpty v-if="items.length === 0" eheader="Debit Notes" econtent="Debit Notes"
            eimg="/src/assets/Img/icons/supplier-mapping.svg" :createline="false" />
          <Tableview v-if="items.length !== 0" v-model:value="items" :data="items" :paginator="true"
            class="p-datatable-gridlines" :rows="10" :rowHover="true" filterDisplay="menu" :loading="loading"
            responsiveLayout="scroll" :columns="headers" dataKey="ID" :selectionMode="false">
            <template v-slot:status="{ data }">
              <RedStatus name="Paid" v-if="data.Status == '2'" />
              <OrangeStatus name="Partially" v-if="data.Status == '1'" />
              <GreenStatus name="UnPaid" v-if="data.Status == '0'" />
            </template>
            <template v-slot:action="{ data }" v-if="showdebitnoteadjust">
              <span class="add">
                <Button :label="isRowApplied(data.DebitNoteID) ? 'Applied' : 'Apply'" class="applybtn"
                  :class="isRowApplied(data.DebitNoteID) ? 'applied-class' : ''" @click="SelectApply(data)" />
              </span>
            </template>
          </Tableview>
        </div>
      </b-col>
    </b-row>
  </b-container>

</template>
<script lang="ts">
import { defineComponent, ref, computed, PropType, watch, onMounted } from "vue";
import Tableview from "../../../../../../components/FormComponents/NormalTable.vue";
import { useRouter } from "vue-router";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import SupplierDebitNoteService from "../../../../../../modules/Inventory/Service/SupplierDebitNoteService";
export default defineComponent({
  components: {
    Tableview,
    SkeletonTableLoader,
    MasterEmpty,
  },
  props: {
    datas: {
      type: Array,
      default: [],
    },
    showdebitnoteadjustment: {
      type: Boolean,
      default: false,
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
    selectedRows: {
      type: Array,
      default: [],
    },
    SelectedDebitNotes: {
      type: Array,
      default: [],
    },
  },
  setup(props, { emit }) {
    const router = useRouter();
    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    //
    const showdebitnoteadjust = ref(props.showdebitnoteadjustment);
    const items = ref([]);
    const activeTabIndex = ref(props.activeIndex);
    const loading = ref(false);
    const SelectedDebitNotes: any = ref(props.selectedRows);
    const supplierdatas: any = ref([]);

    onMounted(() => {
      supplierdatas.value = props.datas;
      showdebitnoteadjust.value = props.showdebitnoteadjustment;
      IsShow();
    });

    const headers = [
      {
        header: "DebitNode Id",
        field: "DebitNote",
        class: "filterdisplaynone",
      },
      {
        header: "Issue Date",
        field: "IssueDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
        hide: showdebitnoteadjust.value,
      },
      {
        header: "Debit Note Amount",
        field: "Amount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },

      {
        header: "Reason",
        field: "Reason",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        hide: showdebitnoteadjust.value,
      },
      {
        header: "Status",
        field: "Status",
        slot: "status",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        hide: showdebitnoteadjust.value,
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone columnfreeze",
        fieldDisplay: "false",
      },
    ];

    watch(
      () => props.datas,
      (newVal: any) => {
        debugger;
        activeTabIndex.value = 0
        supplierdatas.value = newVal;
        IsShow();
      },
      { deep: true }
    );
    watch(
      () => props.activeIndex,
      (newVal: any) => {
        IsShow();
      },
      { deep: true }
    );

    watch(
      () => showdebitnoteadjust.value,
      (newVal: any) => {
        showdebitnoteadjust.value = newVal;
        IsShow();
      },
      { deep: true }
    );

    async function IsShow() {
      try {
        loading.value = true;
        let count = 0;

        const dataresponse = await SupplierDebitNoteService.GetDebitNoteList(
          supplierdatas.value.SupplierId,
          usersData.OrganizationId,
          usersData.BranchId
        );
        if (showdebitnoteadjust.value == true) {
          items.value = dataresponse["result"]
            .filter((item) => item["Status"] != 2)
            .map((item: any) => {
              count = count + 1;
              item.RowNumber = count;
              return item;
            });
        } else {
          items.value = dataresponse["result"].map((item: any) => {
            count = count + 1;
            item.RowNumber = count;
            return item;
          });
        }

        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    // Function Apply or remove the DebitNoteAmount
    const SelectApply = (data: any) => {
      debugger;
      const exists = SelectedDebitNotes.value.some(
        (item) => item.DebitNoteID === data.DebitNoteID
      );

      if (!exists) {
        SelectedDebitNotes.value.push({
          DebitNoteID: data.DebitNoteID,
          DebitNote: data.DebitNote,
          InvoiceID: data.InvoiceID,
          Amount: data.Amount,
          UsedAmount: 0,
          RowNumber: data.RowNumber, // Ensure RowNumber is included for sorting
        });
      } else {
        const index = SelectedDebitNotes.value.findIndex(
          (item) => item.DebitNoteID === data.DebitNoteID
        );
        if (index > -1) {
          SelectedDebitNotes.value.splice(index, 1);
        }
      }

      // Sort SelectedDebitNotes.value based on RowNumber
      SelectedDebitNotes.value.sort((a, b) => a.RowNumber - b.RowNumber);

      emit('SendDebitNote', SelectedDebitNotes.value);
    };
    const isRowApplied = (rowId) => {
      return SelectedDebitNotes.value.some((item) => item.DebitNoteID === rowId);
    };


    return {
      items,
      loading,
      headers,
      supplierdatas,
      IsShow,
      showdebitnoteadjust,
      activeTabIndex,
      SelectApply,
      isRowApplied,
      SelectedDebitNotes
    };
  },
});
</script>

<style lang="scss" scoped>
.applybtn {
  all: unset;
  background: #4F46E5;
  border-radius: 5px;
  color: #ffffff;
  padding: 6px 14px !important;
}

.applied-class {
  background-color: green;
}

.applied-class:hover {
  background-color: green !important;
}
</style>
